import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import FormButton from '@components/form/form-button';
import { Modal, ModalContent, ModalTitle } from '@components/modal';

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface PreviousPageModalProps {
  open: boolean;
  closeModal: () => void;
  onProceed: () => void;
}

function PreviousPageModal({
  open,
  closeModal,
  onProceed
}: PreviousPageModalProps) {
  const intl = useIntl();
  return (
    <Modal open={open} onCancel={closeModal} footer={null}>
      <ModalTitle>{intl.formatMessage({ id: 'ARE_YOU_SURE' })}</ModalTitle>
      <ModalContent style={{ whiteSpace: 'break-spaces' }}>
        {intl.formatMessage({ id: 'RESET_PROCESS_MODAL_DESC' })}
      </ModalContent>
      <ButtonContainer>
        <FormButton withLeftArrow variant="outlined" onClick={closeModal}>
          {intl.formatMessage({ id: 'CANCEL' })}
        </FormButton>
        <FormButton withRightArrow type="primary" onClick={onProceed}>
          {intl.formatMessage({ id: 'PROCEED' })}
        </FormButton>
      </ButtonContainer>
    </Modal>
  );
}

export default PreviousPageModal;
